
{
  "familyId": "GET-DEEL-KOMMA",
  "questions": [
    {
      "id": "GET-DEEL-KOMMA-001",
      "familyId": "GET-DEEL-KOMMA",
      "module": "Getalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "kommagetallen",
      "subSkill": "delen_door_kommagetal",
      "questionType": "multiple_choice",
      "question": "Een bloemist verdeelt 6 liter water over vaasjes van 0,5 liter. Hoeveel vaasjes kan ze vullen?",
      "options": ["12", "3", "0,12", "5,5"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "numberline",
          "data": {
            "start": 0,
            "end": 6,
            "step": 0.5,
            "marked": [0.5, 1.0, 1.5, 2.0, 2.5, 3.0, 3.5, 4.0, 4.5, 5.0, 5.5, 6.0],
            "label": "6 liter verdeeld in stukken van 0,5 liter"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Delen door 0,5",
            "content": "Delen door 0,5 is hetzelfde als vermenigvuldigen met 2. Of: maak de deler heel door beide getallen × 10.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "deel_door_komma_basis",
      "variantIndex": 1,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Delen door 0,5 is hetzelfde als vermenigvuldigen met 2. 6 ÷ 0,5 = 6 × 2 = 12. Of maak de deler heel: 6 ÷ 0,5 → (6 × 10) ÷ (0,5 × 10) = 60 ÷ 5 = 12. De bloemist kan 12 vaasjes vullen.",
        "solutionSteps": [
          "Delen door 0,5 = vermenigvuldigen met 2",
          "6 × 2 = 12",
          "Of: (6 × 10) ÷ (0,5 × 10) = 60 ÷ 5 = 12"
        ],
        "distractorExplanations": {
          "0": "Goed! 6 ÷ 0,5 = 12. Delen door een half = vermenigvuldigen met 2.",
          "1": "Je dacht waarschijnlijk dat je moet vermenigvuldigen. Maar 6 × 0,5 = 3, terwijl de vraag is 6 ÷ 0,5 = 12. Onthoud: delen door een half geeft een groter getal, niet kleiner.",
          "2": "Je dacht waarschijnlijk dat de komma in het antwoord blijft. Maar 6 ÷ 0,5 = 12, niet 0,12. Onthoud: maak de deler heel door × 10, dan verdwijnt de komma.",
          "3": "Je dacht waarschijnlijk dat je moet aftrekken. Maar 6 − 0,5 = 5,5, terwijl de vraag is delen. Onthoud: kijk goed naar het rekenteken."
        }
      }
    },
    {
      "id": "GET-DEEL-KOMMA-002",
      "familyId": "GET-DEEL-KOMMA",
      "module": "Getalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "kommagetallen",
      "subSkill": "delen_door_kommagetal",
      "questionType": "multiple_choice",
      "question": "Een schilder heeft 15 liter verf. Elke muur kost 0,3 liter. Hoeveel muren kan hij verven?",
      "options": ["50", "4,5", "5", "45"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Deler heel maken",
            "content": "Maak de deler heel door beide getallen met 10 te vermenigvuldigen. Zo wordt 15 ÷ 0,3 → 150 ÷ 3.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "deel_door_komma_tienden",
      "variantIndex": 2,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Maak de deler heel door beide getallen × 10. 15 ÷ 0,3 → (15 × 10) ÷ (0,3 × 10) = 150 ÷ 3 = 50. De schilder kan 50 muren verven.",
        "solutionSteps": [
          "Maak de deler heel: beide × 10",
          "15 × 10 = 150 en 0,3 × 10 = 3",
          "150 ÷ 3 = 50"
        ],
        "distractorExplanations": {
          "0": "Goed! 15 ÷ 0,3 = 150 ÷ 3 = 50.",
          "1": "Je dacht waarschijnlijk dat je moet vermenigvuldigen. Maar 15 × 0,3 = 4,5, terwijl de vraag is delen. Onthoud: delen door een kommagetal geeft een groter antwoord.",
          "2": "Je dacht waarschijnlijk dat je door 3 deelt. Maar je deelt door 0,3, niet door 3. Onthoud: maak de deler heel: 150 ÷ 3 = 50, niet 15 ÷ 3 = 5.",
          "3": "Je dacht waarschijnlijk dat je alleen de teller × 10 doet. Maar je moet beide getallen × 10 doen. Onthoud: 150 ÷ 3 = 50, niet 15 ÷ 0,3 = 45."
        }
      }
    },
    {
      "id": "GET-DEEL-KOMMA-003",
      "familyId": "GET-DEEL-KOMMA",
      "module": "Getalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "kommagetallen",
      "subSkill": "delen_door_kommagetal",
      "questionType": "multiple_choice",
      "question": "Een laborant meet 4,8 ml vloeistof af in porties van 0,4 ml. Hoeveel porties krijgt ze?",
      "options": ["12", "1,2", "4,4", "0,12"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Beide kommagetallen heel maken",
            "content": "Als beide getallen een komma hebben, vermenigvuldig dan beide met 10 (of 100). Zo wordt 4,8 ÷ 0,4 → 48 ÷ 4.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "deel_door_komma_beide_komma",
      "variantIndex": 3,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Maak de deler heel door beide getallen × 10. 4,8 ÷ 0,4 → (4,8 × 10) ÷ (0,4 × 10) = 48 ÷ 4 = 12. De laborant krijgt 12 porties.",
        "solutionSteps": [
          "Maak de deler heel: beide × 10",
          "4,8 × 10 = 48 en 0,4 × 10 = 4",
          "48 ÷ 4 = 12"
        ],
        "distractorExplanations": {
          "0": "Goed! 4,8 ÷ 0,4 = 48 ÷ 4 = 12.",
          "1": "Je dacht waarschijnlijk dat je de komma niet verwijdert. Maar 4,8 ÷ 4 = 1,2 — je deelt door 0,4, niet door 4. Onthoud: maak de deler heel: 48 ÷ 4 = 12.",
          "2": "Je dacht waarschijnlijk dat je moet aftrekken. Maar 4,8 − 0,4 = 4,4, terwijl de vraag is delen. Onthoud: kijk goed naar het rekenteken.",
          "3": "Je dacht waarschijnlijk dat de komma in het antwoord blijft. Maar 48 ÷ 4 = 12, niet 0,12. Onthoud: als je beide getallen × 10 doet, verdwijnt de komma."
        }
      }
    },
    {
      "id": "GET-DEEL-KOMMA-004",
      "familyId": "GET-DEEL-KOMMA",
      "module": "Getalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "kommagetallen",
      "subSkill": "delen_door_kommagetal",
      "questionType": "multiple_choice",
      "question": "Een timmerman knipt een touw van 9 meter in stukken van 0,75 meter. Hoeveel stukken krijgt hij?",
      "options": ["12", "6,75", "9,75", "120"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Deler heel maken met × 100",
            "content": "Als de deler twee decimalen heeft, vermenigvuldig dan beide getallen met 100. Zo wordt 9 ÷ 0,75 → 900 ÷ 75.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "deel_door_komma_context",
      "variantIndex": 4,
      "citoDifficulty": 0.44,
      "citoDiscrimination": 0.69,
      "feedback": {
        "explanationText": "Maak de deler heel door beide getallen × 100. 9 ÷ 0,75 → (9 × 100) ÷ (0,75 × 100) = 900 ÷ 75 = 12. De timmerman krijgt 12 stukken touw.",
        "solutionSteps": [
          "Maak de deler heel: beide × 100",
          "9 × 100 = 900 en 0,75 × 100 = 75",
          "900 ÷ 75 = 12"
        ],
        "distractorExplanations": {
          "0": "Goed! 9 ÷ 0,75 = 900 ÷ 75 = 12 stukken.",
          "1": "Je dacht waarschijnlijk dat je moet vermenigvuldigen. Maar 9 × 0,75 = 6,75, terwijl de vraag is delen. Onthoud: delen door een kommagetal geeft een groter antwoord.",
          "2": "Je dacht waarschijnlijk dat je moet optellen. Maar 9 + 0,75 = 9,75, terwijl de vraag is delen. Onthoud: kijk goed naar wat er gevraagd wordt.",
          "3": "Je dacht waarschijnlijk dat je alleen de teller × 100 doet. Maar je moet beide getallen × 100 doen. Onthoud: 900 ÷ 75 = 12, niet 900 ÷ 7,5 = 120."
        }
      }
    },
    {
      "id": "GET-DEEL-KOMMA-005",
      "familyId": "GET-DEEL-KOMMA",
      "module": "Getalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "kommagetallen",
      "subSkill": "delen_door_kommagetal",
      "questionType": "fill_in",
      "question": "Een kok verdeelt 3,6 liter soep in kommetjes van 0,6 liter. Hoeveel kommetjes kan hij vullen? Typ het getal.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["6"],
        "caseSensitive": false,
        "placeholder": "?"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Deler heel maken",
            "content": "Maak de deler heel: beide × 10. 3,6 ÷ 0,6 → 36 ÷ 6 = 6. De kok kan 6 kommetjes vullen.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "deel_door_komma_fill",
      "variantIndex": 5,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Maak de deler heel door beide getallen × 10. 3,6 ÷ 0,6 → (3,6 × 10) ÷ (0,6 × 10) = 36 ÷ 6 = 6. De kok kan 6 kommetjes vullen. Controleer: 6 × 0,6 = 3,6 ✓.",
        "solutionSteps": [
          "Maak de deler heel: beide × 10",
          "3,6 × 10 = 36 en 0,6 × 10 = 6",
          "36 ÷ 6 = 6",
          "Controleer: 6 × 0,6 = 3,6 ✓"
        ]
      }
    }
  ]
}
